import axios from 'axios';

const apiHost = function () {
  // eslint-disable-next-line no-undef
  if (apiPath && typeof apiPath !== 'undefined') {
    // eslint-disable-next-line no-undef
    return apiPath;
  }

  if (typeof import.meta.env.VITE_API_BASE_PATH !== 'undefined') {
    let basepath = '';

    if (!basepath.includes(import.meta.env.VITE_API_PREFIX)) {
      basepath = `${import.meta.env.VITE_API_BASE_PATH}/${import.meta.env.VITE_API_PREFIX}`;
    }
    return basepath;
  }

  const hostname = `${location.hostname.split('.').slice(-2).join('.')}`;
  return `https://api.${hostname}/${import.meta.env.VITE_API_PREFIX}`;
};

const XdebugParameter = import.meta.env.VITE_XDEBUG || 'PHPSTORM';

if (XdebugParameter && document.cookie.indexOf('XDEBUG') !== -1) {
  // Cookie moet bestaan, Gebruik hiervoor Xdebug Helper Chrome Extension
  axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['XDEBUG_SESSION_START'] = XdebugParameter;
    return config;
  });
}

const spaTokenHeader = import.meta.env.VITE_API_TOKEN_HEADER || 'X-Spa-Token';

// eslint-disable-next-line no-undef
const selectedModuleToken = moduleToken ? moduleToken : import.meta.env.VITE_API_TOKEN;
 

// const { moduleToken } = formStore();
if (spaTokenHeader) {
  axios.interceptors.request.use(function (config) {
    config.headers[spaTokenHeader] = selectedModuleToken;
    return config;
  });
}

axios.defaults.baseURL = apiHost();
